// extracted by mini-css-extract-plugin
export var blue = "_4d-h";
export var brand = "_4d-d";
export var darkGrey = "_4d-g";
export var disabled = "_4d-6";
export var disabledSubtle = "_4d-7";
export var error = "_4d-8";
export var green = "_4d-i";
export var grey = "_4d-f";
export var icon = "_4d-0";
export var inherit = "_4d-c";
export var lightGrey = "_4d-e";
export var orange = "_4d-k";
export var pink = "_4d-m";
export var primary = "_4d-1";
export var purple = "_4d-n";
export var quaternary = "_4d-4";
export var quinary = "_4d-5";
export var red = "_4d-l";
export var secondary = "_4d-2";
export var success = "_4d-b";
export var tertiary = "_4d-3";
export var warning = "_4d-9";
export var warningSecondary = "_4d-a";
export var white = "_4d-o";
export var yellow = "_4d-j";